const colors = {
	green: "#90be6d",
	red: "#f94144",
	orange: "#f8961e",
	backgroundGrey: "#121212",
	purple: "#327",
	borderGrey: "#2b2b2b",
	queueItemBg: "#0f0f0f",
	boxHoverWhite: "rgba(255, 255, 255, 0.3)",
};

export default colors;
